module.exports = __webpack_public_path__ + "img/tgi-icon.99891a0d.jpeg";